export default "__VITE_ASSET__DQam$Age__"